<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
  import { mapState } from "vuex"
  import { applyTheme } from '@/utils/theme';
  import {baseerp} from "@/utils/baseUrl";

  export default {
    data(){
      return{
        socket:null,
        baseerp:'',
      }
    },
    mounted() {
      // window.addEventListener('unload', this.saveState)

    },
    created(){
      this.baseerp=baseerp;
      applyTheme(this.baseerp);
      let that=this;
      this.$watch('isLogin',()=>{

        if(that.isLogin==="login"){
          that.socket = that.$getSocket('index');
          that.socket.onmessage=(res)=>{
            // console.log('****app****'+res.data)

          }
          that.socket.onclose=()=>{
            // console.log('****app****关闭')

          }
        }
        // console.log(that.socket,'---that.socket---')


        // console.log('this.isLogin=',that.isLogin=='logout'&&that.socket!=null)
        if (that.isLogin=='logout'&&that.socket!=null){
          // console.log('=======')
            let str=JSON.stringify(this.routerList);
            sessionStorage.setItem('routerList', str);
          that.socket.close()
        }
      })
    },
    methods: {
      saveState() {
        let str=JSON.stringify(this.routerList);
        sessionStorage.setItem('routerList', str);
          // console.log('saveStatesaveState')

      },


    },
    computed:{
      ...mapState(["routerList","isLogin"])
    },
  }
</script>
<style lang="scss">
</style>
